export type InsuranceType = {
  id: string;
  label: string;
  premiumMultiplier: number;
  type: 'death' | 'death-downpayment'
  | 'incapacity' | 'unemployment' |'incapacity-mhe-mortgage' | 'unemployment-mhe-mortgage'
  | 'disaster-mhe-mortgage' | 'death-mhe-mortgage';
  description: string;
  maxPeriods: number | null;
  minPeriods: number | null;
};

export type LoanRequestInsurance = {
  id: string;
  value: { amount: number; currency: 'CLP' | 'CLF'; precision: number };
  createdAt: string;
  updatedAt: string;
  ufCurrency: {
    id: string;
    abbreviation: 'CLP' | 'CLF';
    precision: number;
  };
  insurance: InsuranceType;
};

export const shouldShowMonthlyInsuranceCost = (insuranceData: InsuranceType) => (
  insuranceData.type === 'unemployment-mhe-mortgage'
    || insuranceData.type === 'incapacity-mhe-mortgage'
    || insuranceData.type === 'disaster-mhe-mortgage'
    || insuranceData.type === 'death-mhe-mortgage'
);

export function getInsuranceDisplayAmount(
  insurance: LoanRequestInsurance,
  periods: number,
): number {
  const raw = insurance.value.amount * 10 ** -insurance.value.precision;
  return shouldShowMonthlyInsuranceCost(insurance.insurance)
    ? raw / periods
    : raw;
}
